import 'react-app-polyfill/ie9';
import 'core-js/es/set';
import 'core-js/es/map';

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import(`./${process.env.REACT_APP_CSS}.css`).then(() => {
    //...
});
window.jQuery = $;
window.$ = $;
global.jQuery = $;

class CoverForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contactFilled: false
    };
  }

  submitForm(event) {
    const forms = $('#contact');
    forms.addClass('was-validated');
    if(forms.first()[0].checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  checkNumber(event) {
    if(!isFinite(event.key)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  lastStep(event) {
    const forms = $('#contact');
    forms.addClass('was-validated');
    this.setState({contactFilled: false,

     });

     event.preventDefault();
     event.stopPropagation();
  }

  render() {
    const show_contact = this.state.contactFilled ? 'collapse' :  '';
    return(
      <div>
        <div className={show_contact}>
          <ContactForm checkNumber={i => this.checkNumber(i)} submitForm={i => this.submitForm(i)} />
        </div>
      </div>

    );
  }
}

class SelectImage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const isSelected = this.props.selected == this.props.description ? 'blue-rectangle' : 'rectangle';
    return(
      <div className="flex-parent mt-1">
        <div onClick={this.props.handleClick} className="hover-click mt-4 mr-1">
          <div className={isSelected}>
            <img src={this.props.image} alt={this.props.description} />
          </div>
          <div className="text-center mt-2">
            <span>{this.props.description}</span>
          </div>
        </div>
      </div>
  );
  }
}

class SelectBTN extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const isSelected = this.props.selected == this.props.description ? ' selected' : '';
    return(
    <button onClick={this.props.handleClick} type="button" className={"custombtn ml-2" + isSelected}>
      {this.props.description}
    </button>
  );
  }
}

class Header extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return(
      <div>
      {process.env.REACT_APP_BRAND == "Viking" &&
        <div>
          <div className="blue-line">
          </div>
          <div className="logotxt">
            <span className="vktext">VIKING&nbsp;</span><span className="whitetext">Custom Design Cover Plates</span>
          </div>
          <div className="logoparent">
            <a href="https://www.vikinggroupinc.com" target="_blank"><img src="vikinglogowotagline.svg" alt="Viking Logo"/></a>
          </div>
          <div className="slogan">
            Trusted above all.™
          </div>
          <div className="logoparent brick-parent">
            <div className="brick-before">
            </div>
            <div className="brick">
            </div>
            <div className="brick-after">
            </div>
          </div>
        </div>
      }
      {process.env.REACT_APP_BRAND == "Minimax" &&
        <div>
        <div className="blue-line">
        </div>
        <div className="logotxt">
          <span className="vktext">Minimax Custom Design Cover Plates</span>
        </div>
        <div className="logoparent">
          <a href="http://www.minimax-fire.com" target="_blank"><img src="mxlogo.svg" alt="Minimax Logo"/></a>
        </div>
        <div className="logoparent brick-parent">

        </div>
        </div>
      }
      </div>
    );
  }
}

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      platetype: "Standard",
      color: "White",
      temp: "135 °F"
    };
  }

  typeClick(value) {
    this.setState({platetype: value});
  }

  colorClick(value) {
    this.setState({color: value});
  }

  tempClick(value) {
    this.setState({temp: value});
  }

  render() {
    const showCustom = this.state.color == "Custom Finish" ? '' : ' mt-2 collapse';
    const requiredCustom = this.state.color == "Custom Finish";
    return (
      <div>
        <div className="row">
          <div className="offset-md-2 col-md-8">
            <div className="form-row">
                <h3 className="header-txt">Custom Designed Cover Plates by {process.env.REACT_APP_BRAND} – Project Request Form</h3>
                <p>{process.env.REACT_APP_BRAND} now offers the ability for you to customize flat cover plates with virtually any artwork, logo or design.  Our patent-pending process, which is UL Listed and FM Approved, is available for any flat concealed cover plate type, finish, and temperature rating.</p>
                <div className="row flex-nowrap">
                  {process.env.REACT_APP_BRAND == "Minimax" &&
                    <div className="col-md-4 p-0">
                        <img className="w-100" src="img/NewColorerCover copy.png" alt="Custom Cover Plate Examples" />
                    </div>
                  }
                  {process.env.REACT_APP_BRAND == "Viking" &&
                    <div className="col-md-4 p-0">
                        <img className="w-100" src="img/NewColorerCover.png" alt="Custom Cover Plate Examples" />
                    </div>
                  }
                  {process.env.REACT_APP_BRAND == "Minimax" &&
                    <div className="col-md-4 p-0">
                        <img className="w-100" src="img/MinimaxCover.png" alt="Custom Cover Plate Examples" />
                    </div>
                  }
                    <div className="col-md-4 p-0">
                      <img className="w-100" src="img/IMG_0985-web.jpg" alt="Custom Cover Plate Examples" />
                    </div>
                  {process.env.REACT_APP_BRAND == "Viking" &&
                    <div className="col-md-4 p-0">
                      <img className="w-100" src="img/IMG_0989-web.jpg" alt="Custom Cover Plate Examples" />
                    </div>
                  }
                </div>

            </div>
            <div className="form-row mb-2 mt-4">
              <span className="header-txt">Step 1 – Select the base cover plate to be customized</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="platetype" >Cover Plate Type</label>
                <div className="form-row space-even mt-n4">
                  <SelectImage image="img/Small.png" description="Standard" selected={this.state.platetype} handleClick={this.typeClick.bind(this, "Standard")} />
                  <SelectImage image="img/Large.png" description="Large" selected={this.state.platetype} handleClick={this.typeClick.bind(this, "Large")}  />
                  <SelectImage image="img/ELO.png" description="ELO" selected={this.state.platetype} handleClick={this.typeClick.bind(this, "ELO")}  />
                  <SelectImage image="img/Sidewall.png" description="Sidewall" selected={this.state.platetype} handleClick={this.typeClick.bind(this, "Sidewall")}  />
                  <SelectImage image="img/Square.png" description="Square" selected={this.state.platetype} handleClick={this.typeClick.bind(this, "Square")} />
                </div>
                <input type="hidden" id="platetype" name="platetype" value={this.state.platetype} />
              </div>
            </div>
            <div className="form-row mt-4 mb-2">
              <span className="header-txt">Step 2 – Specify the base finish (custom painted finishes are acceptable)</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="platecolor">Base Finish</label>
                <div className="form-row space-even mt-n4">
                  <SelectImage image="img/white.png" description="White" selected={this.state.color} handleClick={this.colorClick.bind(this, "White")}  />
                  <SelectImage image="img/ss.png" description="Stainless Steel" selected={this.state.color} handleClick={this.colorClick.bind(this, "Stainless Steel")} />
                  <SelectImage image="img/Ivory.png" description="Ivory" selected={this.state.color} handleClick={this.colorClick.bind(this, "Ivory")}  />
                  <SelectImage image="img/Black.png" description="Black" selected={this.state.color} handleClick={this.colorClick.bind(this, "Black")}  />
                  {process.env.REACT_APP_BRAND == "Minimax" &&
                    <SelectImage image="img/Minimax Cover Plate-Red.png" description="Custom Finish" selected={this.state.color} handleClick={this.colorClick.bind(this, "Custom Finish")} />
                  }
                  {process.env.REACT_APP_BRAND == "Viking" &&
                    <SelectImage image="img/Blue Cover Plate.png" description="Custom Finish" selected={this.state.color} handleClick={this.colorClick.bind(this, "Custom Finish")} />
                  }
                </div>
                <input type="hidden" id="platecolor" name="platecolor" value={this.state.color} />
              </div>
            </div>
            <div className={"form-row" + showCustom}>
              <div className="form-group">
                <label htmlFor="customcolor">Specify Custom Color Paint Code / Description</label>
                <textarea className="form-control" type="text" id="customcolor" minLength="3" required={requiredCustom} placeholder="Description of custom color" name="customcolor"></textarea>
              </div>
            </div>
            <div className="form-row mt-4 mb-2">
              <span className="header-txt">Step 3 – Specify the cover plate temperature rating</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="platetemp">Cover Plate Temperature</label>
                <div className="form-row">
                  <SelectBTN description="135 °F" selected={this.state.temp} handleClick={this.tempClick.bind(this, "135 °F")} />
                  <SelectBTN description="165 °F" selected={this.state.temp} handleClick={this.tempClick.bind(this, "165 °F")}  />
                </div>
                <input type="hidden" value={this.state.temp} id="platetemp" name="platetemp" />
              </div>
            </div>
            <div className="form-row mt-4 mb-2">
              <span className="header-txt">Step 4 – Enter required quantity, desired delivery date, and any additional comments</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="customcolor">Required Cover Plate Quantity</label>
                <input className="form-control" min="1" step="1" pattern="\d+" onKeyPress={this.props.checkNumber} name="quantity" type="tel" id="quantity" placeholder="1" required></input>
                <div className="invalid-feedback">
                  Please provide a valid quantity.
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="delivery">Required Delivery Date</label>
                <input className="form-control" name="delivery" id="delivery" type='date' min='2019-01-01' required></input>
                <div className="invalid-feedback">
                  Please provide a valid required delivery date. It must be in the future!
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="customcolor">Additional Instructions or Comments</label>
                <textarea className="form-control" name="instructions" id="instructions" placeholder="Additional Comments and Special Instructions"></textarea>
              </div>
            </div>
            <div className="form-row mb-2 mt-4">
              <span className="header-txt">Step 5 – Your contact information</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input minLength="3" className="form-control" name="name" id="name" placeholder="Name" required></input>
                <div className="invalid-feedback">
                  Please provide a valid contact individual.
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="company">Company Name</label>
                <input minLength="3" className="form-control" name="company" id="company" placeholder="Company" required></input>
                <div className="invalid-feedback">
                  Please provide a valid company name.
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" className="form-control" name="email" id="email" placeholder="Email" required></input>
                <div className="invalid-feedback">
                  Please provide a valid email.
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input pattern="[0-9]?\(?[0-9]{3}\)?-?[0-9]{3}-?[0-9]{4}" className="form-control" name="phone" type="tel" id="phone" placeholder="123-456-7890" required></input>
                <div className="invalid-feedback">
                  Please provide a valid phone number.
                </div>
              </div>
            </div>
            <div className="form-row mt-4">
                <h3 className="header-txt">Step 6 - Upload Your Artwork File</h3>
                <p>You can choose to provide an artwork file depicting the image you wish to have screen printed on the cover plates.</p>
                <p>Currently accepted file types are: <b>.ai</b>, <b>.eps</b>, <b>.pdf</b>, <b>.png</b>, <b>.jpeg</b>, <b>.jpg</b>, <b>.dxf</b>.</p>
                <p>Additional file types may be usable, we can clarify during the followup if a different file type is supported.</p>
            </div>
            <div className="form-row">
                <div className="form-group">
                  <label htmlFor="image">Artwork File</label>
                  <input type="file" className="form-control-file" accept=".jpg,.jpeg,.png,.eps,.ai,.eps,.pdf,.dxf" name="image" id="image"/>
                  <input type="hidden" name="MAX_FILE_SIZE" value="20971520"/>
                </div>
            </div>
            <div className="form-row mb-2">
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" id="artworkhelp" name="artworkhelp"/>
                  <label className="form-check-label" forhtml="artworkhelp">Need help creating artwork? {process.env.REACT_APP_BRAND} can help.  Please check this box if interested.</label>
                </div>
            </div>
            <div className="form-row mt-4">
                <h3 className="header-txt">Step 7 - Disclaimer and Terms & Conditions</h3>
                <p>Any custom order request with inappropriate, lewd, or profane content, as determined by {process.env.REACT_APP_BRAND}, is subject to cancellation.  By checking this box, you the customer are acknowledging that there are no trademark violations or copyright infringement issues for the requested artwork to be screen printed on the fire sprinkler cover plate.  The customer bears complete responsibility for verifying this information.  For any artwork that is protected by copyright or trademark, {process.env.REACT_APP_BRAND} requires an authorization letter from the owner of said trademark prior to order acceptance.</p>
            </div>
            <div className="form-row">
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" id="trademark" required name="trademark"/>
                  <label className="form-check-label" forhtml="trademark">I certify I have the rights to this image, agree to the above disclaimer, and wish to be contacted in regards to this request.</label>
                  <div className="invalid-feedback">
                    Please agree to the Terms & Conditions or we cannot process your request!
                  </div>
                </div>
            </div>
            <div className="form-row">
              <div className="mt-3 mb-3 col-md-12 text-center">
                <button className="custombtn" onClick={this.props.submitForm} type="submit">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export {Header, CoverForm}
